import { Dimension } from "@/types/mapping";
import axiosInstance from "../axios-instance";
import { TagExistsResponse } from "./type";
import { AxiosResponse } from "axios";

export const getTagExists = async (
  workbookId: string,
  koLabel: string,
  enLabel: string,
  dimension: Dimension,
): Promise<TagExistsResponse> => {
  const response: AxiosResponse<TagExistsResponse> = await axiosInstance.get(
    `/v2/tags/exists`,
    {
      params: {
        workbookId,
        koLabel,
        enLabel,
        dimension,
      },
    },
  );

  return response.data as TagExistsResponse;
};
